import { serialize } from 'cookie';
export function serializeCookie({ name, value }) {
    return serialize(name, value);
}
export function mapCookieToHeaders(cookie) {
    if (cookie) {
        return { cookie: serializeCookie(cookie) };
    }
    else {
        return {};
    }
}
//# sourceMappingURL=cookies.js.map